import React from 'react';
import ReactDOM from 'react-dom';
import './styles/index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {isStagingOrDev} from "./services/apis";

let root: any = document.getElementById('sd-app-root');
root.setAttribute('style', `position:relative;z-index:1;`)
ReactDOM.render(
    <React.StrictMode>
        <App/>
    </React.StrictMode>,
    root
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

try {
    let windowDocument = (window as any)
    let CB = windowDocument.Cookiebot
    if (!isStagingOrDev() && CB) {

        if (CB.consent.statistics) {
            if(windowDocument.gtag){
            }
        }

        if (CB.consent.marketing) {
            if (windowDocument.fbq){
                windowDocument.fbq('track', 'PageView');
            }
        }

    }
} catch (ex) {
    console.log(ex)
}
